// extracted by mini-css-extract-plugin
export default {"radio":"accountTypeRadio_radio__ddDUF"};